import React from 'react';
import { Link } from 'react-router-dom';
import ContentLayout from '../layout/ContentLayout';

export default function NotFoundPage() {
	return (
		<ContentLayout contentHeader='Page not found'>
			<p className='content-paragraph'>This page could not be found. <Link to='/about'>Explore Afra’s music services</Link> or <Link to='/contact'>get in touch</Link>.</p>
		</ContentLayout>
	);
}
